import React from 'react';
import './PersonBiography.scss';

const PersonBiography = ({ children, biography }) => {
  return (
    <div className="person-biography">
      <h3 className="person-biography-title">{children}</h3>
      <p className="person-biography-content">{biography}</p>
    </div>
  );
};

export default PersonBiography;
